export default __webpack_public_path__ + "static/media/e-commerce.995579a3.svg";